const title = "Baseball Team Banners – Custom Designs & Templates | Team Banner Sports";
export {title}